import React from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';

import { BillingSubscription } from 'apps/payment/subscription';
import { PaymentMethods } from 'apps/payment/method';
import { PaymentHistory } from 'apps/payment/history';
import { Collaborators } from 'apps/profile/collaborators';

@inject('routerStore')
@observer
export class BillingSettings extends React.Component {
  render() {
    return (
      <div className='-mt-1'>
        <BillingSubscription />
        <Collaborators />
        <PaymentMethods />
        <PaymentHistory />
      </div>
    );
  }
}

BillingSettings.propTypes = {
  routerStore: PropTypes.object,
};
